<template>
  <div class="width-full">
    <div class="float-left width-full">
      <v-row class="px-4 py-0">
        <v-col v-for="ticker in tickers" :key="ticker._id" cols="2" class="pl-2">
          <div v-if="tickers.length > 0" class="float-left width-full my-divider">
            <div class="width-full pr-4">
              <span class="quote-name">{{ticker.ticker}}</span>
              <span class="quote-last">{{ticker.close.toFixed(2)}}</span>
            </div>
            <div v-if="ticker.ticks == 0" class="width-full float-left">
              <span class="quote-change float-left text-grey">waiting...</span>
            </div>
            <div v-else class="width-full float-left" :class="ticker.close > ticker.open ? 'profit':'loss'">
              <span class="quote-change float-left">{{(ticker.close/ticker.open*100 - 100).toFixed(2)}}%</span>
              <span class="quote-diff pt-2">{{(ticker.close - ticker.open).toFixed(2)}}</span>
            </div>
          </div>
        </v-col>
        
      </v-row>
    </div>
    <!--
    <div class="float-right" style="width: 3%">
      <v-icon v-on="on" class="text-grey">add_circle_outline</v-icon>
    </div>
    -->
  </div>
</template>

<script>
import axios from "axios";
export default {

asyncComputed: {
    tickers: {
      get() {
        return new Promise((resolve, reject) => {
          axios
            .post("https://tradeinpool.com:3006/request/tickers/", {
            })
            .then(response => {
              resolve(response.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      default: []
    }
},
sockets: {
    MARKET: function(data) {
        this.tickers.forEach((ticker,index) => {
            if (data[0] == ticker.ticker){
                this.tickers[index].close = data[2]
                this.tickers[index].ticks += 1
            }
        })
    },
}

};
</script>

<style scoped>
.ticker-container {
  background-color: #28303d;
}
.quote-widget {
  padding: 0px;
  background-color: #28303d;
  max-height: 50px;
  border-right: 1px solid rgba(255, 255, 255, 0.12);
}

.quote-diff {
  font-size: 11px;
  font-family: 'Roboto Condensed', sans-serif;
  padding: 0px;
  float: left;
  margin-left: 10px;
}
.quote-change {
    font-family: 'Roboto Condensed', sans-serif;
  font-size: 18px;
  font-weight: bold;
  float: left;
}
.quote-bottom {
  border: 1px solid red;
  width: 100%;
}
.quote-name {
  font-size: 11px;
  float: left;
}

.quote-last {
    font-family: 'Roboto Condensed', sans-serif;
  font-size: 11px;
  float: right;
}
.fullwidth {
  width: 100%;
  float: left;
  padding: 0px;
}

.tickers-settings {
  background-color: #28303d;
  max-width: 50px;
}

.my-divider {
  border-right: 1px solid rgb(69, 72, 82);
}
</style>